<template>
	<div id="paymentmodal">
    <button
      type="button"
      class="btn btn-primary pull-right"
      @click="showModal"
      data-toggle="tooltip"
      data-placement="top"
      :title="(paid == 'true') ? '' : paying_modal_message"
    >
    {{( paid == "true") ? agreement : text }}
    </button>

    <div id="modaltop" class="modal fade show" tabindex="-1" role="dialog" style="display:block;" v-show="isModalVisible">
      <div id="modalmid" class="modal-dialog">
        <div class="modal-content">
          <spinner :loading="isLoading" />
          <div class="modal-body" id="paymentcontent" style="color:black;text-align:center;">
          </div>

          <div class="modal-footer" style="text-align: center;border-top: none;">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from './components/modal.vue'
import Spinner from './components/spinner.vue'
export default {
	components: {
    Modal,Spinner
	},
  props: ["name", "next", "text", "agreement", "sign", "accept", "page", "paid", "paying_modal_message"],
  data() {
    return {
      isLoading: false,
      isModalVisible: false,
    }
  },
  methods: {
    submit(){
      console.log(this);
    },
    closeYes(){
    },
    notLoading(){
      this.isLoading = false
    },
    showModal() {
      if (this.paid == "true"){
        window.location = this.accept;
        return
      }
      let pm = this;
      this.isLoading = true;
      $.ajaxSetup({
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
      });
      $.ajax({
        type: "GET",
        data_type: 'html',
        data: {
          page: this.page
        },
        url: this.next + "payment/get_payment_content",
        success: function(result) {
          pm.notLoading();
          $('#paymentcontent').html(result['html']);
        },
        error: function(){
             //handle error situation if post request failed
        }
      });
      //window.jQuery(this.$refs.modal.$el).modal('show')
      //$('#modaltop').modal('show');
      this.isModalVisible = true;
    },
    closeModal() {
     //window.jQuery(this.$refs.modal.$el).modal('hide')
     //$('#modaltop').modal('hide');
     this.isModalVisible = false;
    },
  }
}
</script>

<style lang="scss">

*, *::before, *::after {
	box-sizing: border-box;
}

#paymentmodal {
	margin: 0 auto;
	line-height: 1.4;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: blue;
}

h1 {
	text-align: center;
}
</style>
